import { styled } from "@linaria/react";
import { StyledListItem } from "../../List/StyledList";
import { ButtonBase } from "../../ui/Button/StyledButton";
import { getTypographyBase } from "../../ui/Typography/Typography";
export const StyledSummary = /*#__PURE__*/styled('div')({
  name: "StyledSummary",
  class: "StyledSummary_s1qr6ysv"
});
export const StyledSummaryItemBody = /*#__PURE__*/styled('div')({
  name: "StyledSummaryItemBody",
  class: "StyledSummaryItemBody_s10yfnws"
});
export const StyledSummaryCol = /*#__PURE__*/styled('div')({
  name: "StyledSummaryCol",
  class: "StyledSummaryCol_s1jfag78"
});
export const StyledSummaryItem = /*#__PURE__*/styled(StyledListItem)({
  name: "StyledSummaryItem",
  class: "StyledSummaryItem_sjbvxnt",
  vars: {
    "sjbvxnt-0": [props => props.color || "inherit"]
  }
});

require("./StyledSummary.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledSummary.tsx");